import { render, staticRenderFns } from "./LikeCount.vue?vue&type=template&id=2007ef98"
import script from "./LikeCount.vue?vue&type=script&lang=js"
export * from "./LikeCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports